const gte = function (value, test, options) {
    if (value >= test) {
        return options.fn(this);
    }
    return options.inverse(this);
};

module.exports = gte;



// WEBPACK FOOTER //
// ./src/scripts/core/templates/templates/gte.js